import { render } from "./AppFileView.vue?vue&type=template&id=453eb658&scoped=true&ts=true"
import script from "./AppFileView.vue?vue&type=script&lang=ts"
export * from "./AppFileView.vue?vue&type=script&lang=ts"

import "./AppFileView.vue?vue&type=style&index=0&id=453eb658&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453eb658"]])

export default __exports__